'use client';

import { FC } from 'react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import HotdeskButton from './HotdeskButton';
import styles from './LongTermLeaseSection.module.scss';
export interface LongTermLeaseSectionProps {
  onContactSales: () => void;
  onCalculator: () => void;
}
const LongTermLeaseSection: FC<LongTermLeaseSectionProps> = ({
  onContactSales,
  onCalculator
}) => {
  const t = useTranslations();
  return <section className={styles.section} data-sentry-component="LongTermLeaseSection" data-sentry-source-file="LongTermLeaseSection.tsx">
            <div className={styles.header}>
                <h2 className={styles.title}>{t('longTermLease.title')}</h2>
                <p className={styles.subtitle}>{t('longTermLease.subtitle')}</p>
            </div>

            <div className={styles.content}>
                <div className={styles.imageColumn}>
                    <div className={styles.imageWrapper}>
                        {/* TODO: Replace with proper long-term-lease-specific image */}
                        <Image src="https://hotdesk-assets.s3.eu-west-1.amazonaws.com/landing_pages/web_v2/home_v4/long-term-lease-office.jpg" alt="Modern office space" fill className={styles.image} data-sentry-element="Image" data-sentry-source-file="LongTermLeaseSection.tsx" />
                        <div className={styles.imageOverlay} />
                        <p className={styles.imageText}>
                            {t('longTermLease.imageCaption')}
                        </p>
                    </div>
                </div>

                <div className={styles.cardsColumn}>
                    <div className={styles.card}>
                        <div className={styles.cardHeader}>
                            <svg className={styles.cardIcon} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-source-file="LongTermLeaseSection.tsx">
                                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-sentry-element="path" data-sentry-source-file="LongTermLeaseSection.tsx" />
                            </svg>
                            <h3 className={styles.cardTitle}>{t('longTermLease.whyChooseUs')}</h3>
                        </div>
                        <ul className={styles.bulletList}>
                            <li className={styles.bulletItem}>
                                <svg className={styles.checkIcon} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-source-file="LongTermLeaseSection.tsx">
                                    <circle cx="10" cy="10" r="10" fill="#000" data-sentry-element="circle" data-sentry-source-file="LongTermLeaseSection.tsx" />
                                    <path d="M6 10l3 3 5-5" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-sentry-element="path" data-sentry-source-file="LongTermLeaseSection.tsx" />
                                </svg>
                                <span>{t.rich('longTermLease.bullet1', {
                  strong: chunks => <strong>{chunks}</strong>
                })}</span>
                            </li>
                            <li className={styles.bulletItem}>
                                <svg className={styles.checkIcon} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-source-file="LongTermLeaseSection.tsx">
                                    <circle cx="10" cy="10" r="10" fill="#000" data-sentry-element="circle" data-sentry-source-file="LongTermLeaseSection.tsx" />
                                    <path d="M6 10l3 3 5-5" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-sentry-element="path" data-sentry-source-file="LongTermLeaseSection.tsx" />
                                </svg>
                                <span>{t('longTermLease.bullet2')}</span>
                            </li>
                        </ul>
                    </div>

                    <div className={styles.card}>
                        <h3 className={styles.cardTitle}>{t('longTermLease.saveOnRent')}</h3>
                        <p className={styles.cardDescription}>
                            {t('longTermLease.saveOnRentDesc')}
                        </p>
                        <div className={styles.cardButtons}>
                            <HotdeskButton variant="primary" size="md" onClick={onContactSales} data-sentry-element="HotdeskButton" data-sentry-source-file="LongTermLeaseSection.tsx">
                                {t('longTermLease.contactSales')}
                            </HotdeskButton>
                            <HotdeskButton variant="secondary" size="md" onClick={onCalculator} data-sentry-element="HotdeskButton" data-sentry-source-file="LongTermLeaseSection.tsx">
                                {t('longTermLease.savingsCalculator')}
                            </HotdeskButton>
                        </div>
                    </div>
                </div>
            </div>
        </section>;
};
export default LongTermLeaseSection;